import React from 'react'
import './prototype.css';
import PageLayout from "../templates/PageLayout";
import ReactMarkdown from 'react-markdown';

class Prototypes extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            prototypes: null,
        }
    }

    componentDidMount() {
        fetch('data/prototypes/prototypes.json')
            .then(response => response.json())
            .then(prototypes => this.setState({prototypes}))
            .catch(reason => console.log('Error ' + reason))
    }

    render() {

        const prototypes = this.state.prototypes;
        let prototypeList;

        if (prototypes == null)
            prototypeList = <ul></ul>;
        else
            prototypeList = (<ul>{
                this.state.prototypes.map((link) =>
                    <li className={"prototypeItem"}>
                        <div className={"text"}>
                            <a href={link.url} target={"_blank"}>{link.label}</a>
                            <ReactMarkdown source={link.text}/>
                        </div>
                        <div>
                            <img src={link.image} alt="A Prototype Screenshot" className={"prototypeImage"}/>
                        </div>
                    </li>
            )}</ul>)

        return (<PageLayout><h2>Prototypes</h2>{prototypeList}</PageLayout>);
    }

}

export default Prototypes;